import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/82a76fae-d8b8-4d39-b359-c71dcac4839a";
export const REGISTER_URL = "https://a.ntrk2.com/2a1e951d-bc69-474d-b3eb-8f9eec173bdd";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://richyph.loadprkw2a.com/download?openExternalBrowser=1&id=95oh2f1lgttv2y2";

export * from "./codes";
export * from "./context";
